export const siteNav = {
  officialUrl: "https://www.aiqingdao.com",
  backupUrls: [
    { label: "备用地址一", url: "https://aiqingdao1.com" },
    { label: "备用地址二", url: "https://aiqingdao2.com" },
    { label: "备用地址三", url: "https://aiqingdao3.com" },
  ],
};

export const navLinks = [
  { label: "首页", path: "/" },
  { label: "最新地址", path: "/category/latest-url" },
  { label: "使用指南", path: "/category/guide" },
  { label: "常见问题", path: "/category/faq" },
  { label: "安全建议", path: "/category/safety" },
  { label: "关于我们", path: "/about" },
];

export const features = [
  {
    id: "feature-1",
    icon: "ri-shield-check-line",
    title: "官方认证入口",
    description: "所有网址均经过官方认证，确保用户访问的是真实可靠的爱情岛平台，杜绝钓鱼网站和虚假链接的风险。",
  },
  {
    id: "feature-2",
    icon: "ri-refresh-line",
    title: "实时更新地址",
    description: "我们持续监控爱情岛网址变更情况，一旦官方入口发生变化，将在第一时间更新本页面的所有链接地址。",
  },
  {
    id: "feature-3",
    icon: "ri-guide-line",
    title: "详细使用指南",
    description: "提供完整的平台注册、登录、功能使用教程，帮助新用户快速上手，充分体验爱情岛的全部功能。",
  },
  {
    id: "feature-4",
    icon: "ri-shield-user-line",
    title: "安全防护建议",
    description: "提供全面的网络安全建议，帮助用户识别钓鱼网站、保护个人隐私，确保在爱情岛上的每次访问都安全无忧。",
  },
  {
    id: "feature-5",
    icon: "ri-customer-service-2-line",
    title: "7×24小时支持",
    description: "如果您在使用过程中遇到任何问题，我们的客服团队全天候为您提供帮助，确保您的访问体验顺畅无忧。",
  },
  {
    id: "feature-6",
    icon: "ri-bookmark-line",
    title: "收藏即更新",
    description: "将本页加入书签，随时打开即可获取爱情岛最新官方网址，无需反复搜索，省时又省力。",
  },
];

export const announcements = [
  {
    id: "ann-1",
    date: "2024-12-15",
    title: "爱情岛网址2024年12月最新入口更新通知",
    summary: "由于近期网络环境变化，爱情岛官方入口地址已更新。请通过本页获取最新有效链接，确保正常访问平台。",
    isNew: true,
  },
  {
    id: "ann-2",
    date: "2024-11-28",
    title: "关于防范假冒爱情岛网址的重要安全提醒",
    summary: "近期发现多起假冒爱情岛网址的诈骗案件，请用户务必通过本页官方认证入口访问，切勿轻信搜索引擎中的广告链接。",
    isNew: true,
  },
  {
    id: "ann-3",
    date: "2024-11-10",
    title: "爱情岛平台功能升级公告——全新界面体验",
    summary: "爱情岛平台已完成重大版本更新，新增多项互动功能，优化了用户界面和匹配算法，为用户带来更优质的社交体验。",
    isNew: false,
  },
  {
    id: "ann-4",
    date: "2024-10-22",
    title: "爱情岛备用地址更新——三线备用确保访问畅通",
    summary: "为保证用户在任何网络环境下都能顺利访问，我们新增了第三条备用线路，建议用户收藏本页以便随时获取最新地址。",
    isNew: false,
  },
];

export const faqItems = [
  {
    id: "faq-1",
    question: "如何确认当前访问的是爱情岛官方网站？",
    answer: "请通过本页面提供的官方入口链接访问。官方网址均采用HTTPS加密协议，浏览器地址栏会显示安全锁标识。同时，官方网站界面精美、功能完善，不会出现弹窗广告或要求下载不明软件的情况。如不确定，可以通过本页客服渠道进行核实。",
  },
  {
    id: "faq-2",
    question: "为什么爱情岛网址会经常变更？",
    answer: "由于互联网环境的复杂性，部分网络服务商可能会对特定网站进行限制。为保障用户能够持续稳定地访问平台，爱情岛会不定期更新访问入口地址。建议用户将本导航页加入浏览器书签，以便随时获取最新有效的访问地址。",
  },
  {
    id: "faq-3",
    question: "备用地址和官方入口有什么区别？",
    answer: "官方入口是爱情岛的主访问地址，具有最高的稳定性和安全性。备用地址是在官方入口因网络原因暂时无法访问时提供的替代方案，功能与官方入口完全一致，使用体验相同。建议优先使用官方入口，备用地址作为应急选择。",
  },
  {
    id: "faq-4",
    question: "如何避免访问到假冒的爱情岛网站？",
    answer: "首先，始终通过本页提供的官方入口进行访问，不要通过搜索引擎的广告链接进入。其次，注意检查网址拼写是否正确，官方网址不存在拼写变体。最后，如果在网站上遇到要求支付费用、下载不明APP或提供银行卡信息的情况，请立即退出，这很可能是假冒网站。",
  },
  {
    id: "faq-5",
    question: "访问时提示\"无法连接\"怎么办？",
    answer: "遇到无法连接的情况时，请按以下步骤排查：1）尝试切换不同的备用地址；2）检查本地网络连接是否正常；3）尝试更换网络环境（如从WiFi切换到移动数据）；4）清除浏览器缓存和Cookie后重试；5）如仍无法解决，可联系我们的客服获取最新可用地址。",
  },
  {
    id: "faq-6",
    question: "本导航页的地址多久更新一次？",
    answer: "我们设有专门的监测系统，7×24小时持续监控爱情岛官方入口的可用性。一旦发现地址变更或访问异常，团队会在30分钟内完成信息核实并更新本页内容。建议您每次访问前刷新页面，以确保获取的是最新地址信息。",
  },
];

export const safetyTips = [
  {
    id: "safety-1",
    icon: "ri-lock-line",
    title: "认准HTTPS加密",
    content: "访问爱情岛官方网站时，地址栏应以https://开头并显示安全锁图标。任何以http://开头的地址都存在安全隐患。",
  },
  {
    id: "safety-2",
    icon: "ri-eye-off-line",
    title: "保护个人隐私",
    content: "切勿在非官方渠道输入账号密码，不要将验证码告知他人。定期修改密码，使用强密码组合提升账户安全。",
  },
  {
    id: "safety-3",
    icon: "ri-error-warning-line",
    title: "识别钓鱼网站",
    content: "钓鱼网站常通过搜索引擎广告、短信链接和社交媒体私信传播。注意核对网址拼写，官方不会通过弹窗索要个人信息。",
  },
  {
    id: "safety-4",
    icon: "ri-smartphone-line",
    title: "官方渠道下载",
    content: "如需下载爱情岛APP，请通过本页提供的官方链接或在官方应用商店搜索下载，切勿安装来源不明的安装包。",
  },
];

export const stats = [
  { value: "500万+", label: "累计服务用户" },
  { value: "99.9%", label: "网址可用率" },
  { value: "30分钟", label: "地址更新响应" },
  { value: "7×24", label: "全天候监测" },
];